import { render } from "./add-face-template-modal.vue?vue&type=template&id=1347fe0c&scoped=true"
import script from "./add-face-template-modal.vue?vue&type=script&lang=js"
export * from "./add-face-template-modal.vue?vue&type=script&lang=js"

import "./add-face-template-modal.vue?vue&type=style&index=0&id=1347fe0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1347fe0c"]])

export default __exports__